<template>
    <popup-modal
        v-if="template"
        :without-padding="true"
        position="center"
        @close="$emit('close')"
    >
        <div class="w-600">
            <div class="p-32">
                <h1 class="text-heading-1 font-semibold mb-6">
                    {{
                        $t('settings.interview-templates.duplicate.title', {
                            type: this.$t(`settings.${this.moduleInfo.templateModel}.single`)
                        })
                    }}
                </h1>
                <p v-if="countQuestions > 0"
                   class="text-primary-80 mr-32">
                    {{
                        $t(`settings.${this.moduleInfo.templateModel}.duplicate.description_with_count`, {
                            amount: countQuestions,
                            type: this.$t(`settings.${this.moduleInfo.model}.title`)
                        })
                    }}
                </p>
                <p class="text-primary-80 mr-32 mb-16">
                    {{ $t(`settings.${this.moduleInfo.templateModel}.duplicate.description`) }}
                </p>

                <p class="block mb-8 first-letter:uppercase">{{
                        $t(`settings.${this.moduleInfo.templateModel}.template`)
                    }}: {{ template['title'][this.moduleInfo.title.locale] }}</p>
                <ul v-if="countQuestions > 0"
                    class="border border-primary-5 rounded py-4 px-16 shadow-sm divide-y divide-primary-5 w-4/5 overflow-y-auto max-h-320">
                    <li v-for="(child, index) in children" class="py-8 flex space-x-8">
                        <strong class="text-secondary-80">
                            {{ moduleInfo.text.item_short }} {{ index + 1 }}
                        </strong>
                        <span>{{ title(child) }}</span>
                    </li>
                </ul>
                <p v-else>{{
                        $t(`settings.${this.moduleInfo.templateModel}.duplicate.no_${this.moduleInfo.model}_found`, {
                            type: this.$t(`settings.${this.moduleInfo.model}.title`)
                        })
                    }}</p>
            </div>

            <div class="bg-primary-5 py-20 px-24 flex justify-end space-x-16">
                <button :disabled="working"
                        class="text-center rounded bg-white hover:bg-primary-5 px-20 py-8 shadow text-body first-letter:uppercase"
                        role="button"
                        @click="$emit('close')">
                    {{ $t('general.cancel') }}
                </button>

                <button :disabled="working"
                        class="flex items-center text-center rounded text-white bg-secondary-80 hover:bg-secondary px-20 py-8 text-body first-letter:uppercase"
                        role="button"
                        @click="$emit('confirm')">
                    {{ $t('general.duplicate') }}

                    <svg-icon v-if="working" class="animate-spin w-20 h-20 ml-10 -mr-12" size="small" type="loader"/>
                </button>
            </div>
        </div>
    </popup-modal>
</template>

<script>

import PopupModal from './ui/PopupModal';
import Loading from './ui/Loading';
import SvgIcon from './ui/SvgIcon';
import {mapState} from 'pinia';
import {useMainStore} from '../state/store';

export default {
    components: {SvgIcon, Loading, PopupModal},
    props: {
        template: Object,
        working: Boolean,
    },
    computed: {
        ...mapState(useMainStore, ['templateModuleInfo']),
        moduleInfo() {
            return this.templateModuleInfo;
        },
        children() {
            return this.template[this.moduleInfo.children];
        },
        countQuestions() {
            return this.children.length;
        },
    },
    methods: {
        title(item) {
            let attribute = this.moduleInfo.title.attribute;
            let locale = this.moduleInfo.title.locale || null;

            return locale ? item[attribute][locale] : item[attribute]
        },
    }
};
</script>
